/* eslint-disable @scandipwa/scandipwa-guidelines/jsx-no-props-destruction */
/* eslint-disable react/forbid-prop-types */
/**
 * @author Vladislavs Zimnikovs <vladislavs.zimnikovs@scandiweb.com>
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package puma-mx
 */

import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import { connect } from 'react-redux';

import SizeChartPopupComponent from 'Component/SizeChartPopup/SizeChartPopup.component';
import { SIZE_CHART_POPUP_ID } from 'Component/SizeChartPopup/SizeChartPopup.config';

/** @namespace Scandipwa/Component/SizeChartPopup/Container/mapStateToProps */
export const mapStateToProps = (state) => ({
    reviewPayload: state.PopupReducer.popupPayload[SIZE_CHART_POPUP_ID] || {},
    code: state.ConfigReducer.code
});

/** @namespace Scandipwa/Component/SizeChartPopup/Container/mapDispatchToProps */
export const mapDispatchToProps = () => ({});

/** @namespace Scandipwa/Component/SizeChartPopup/Container */
export class SizeChartPopupContainer extends PureComponent {
    static propTypes = {
        reviewPayload: PropTypes.object.isRequired,
        code: PropTypes.string.isRequired
    };

    render() {
        return (
            <SizeChartPopupComponent
              { ...this.props }
              { ...this.state }
            />
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SizeChartPopupContainer);
